import type { ReactNode } from 'react'

type Tone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger'

interface Props {
  tone?: Tone
  children: ReactNode
  className?: string
}

const TONE: Record<Tone, string> = {
  neutral: 'bg-[var(--color-elevated)] text-[var(--color-text-muted)] border-[var(--color-border)]',
  accent: 'bg-[var(--color-accent-soft)] text-[var(--color-accent-hover)] border-[var(--color-accent)]/30',
  success: 'bg-[var(--color-success)]/10 text-[var(--color-success)] border-[var(--color-success)]/30',
  warning: 'bg-[var(--color-warning)]/10 text-[var(--color-warning)] border-[var(--color-warning)]/30',
  danger: 'bg-[var(--color-danger)]/10 text-[var(--color-danger)] border-[var(--color-danger)]/30',
}

export default function Badge({ tone = 'neutral', children, className = '' }: Props) {
  return (
    <span
      className={[
        'inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium border',
        TONE[tone],
        className,
      ].join(' ')}
    >
      {children}
    </span>
  )
}
